<div *ngIf="selectedUser" class="chat-view-container">

  <div class="chat-header">
    <div class="left-section">
      <ion-icon name="people-circle-outline" class="avatar-icon"></ion-icon>
      <div class="group-head">
        <h2 class="chat-title">{{ targetUser }}</h2>
        <div class="online-status" [ngClass]="{'online': status === 'online', 'offline': status === 'offline'}">
          {{ status }}
        </div>
      </div>
    </div>
  </div>
  <div #scrollContainer  class="chat-messages">
    <div class="chat-window">
      <div *ngFor="let msg of messages" [ngClass]="{'message': true, 'my-message': msg.sender === currentUser}">
        <div class="message-container"
          [ngClass]="{'left-message': msg.sender === targetUser, 'right-message': msg.sender === currentUser}">
          <ion-icon name="person-circle-outline" class="avatar-icon"></ion-icon>
          <div class="message-content" style="width: 100%;max-width: 400px;">
            <!-- <h3 class="chat-name">{{ msg.sender }}</h3> -->
            <p class="message-text">{{ msg.content }}</p>
            <div class="message-time-container">
              <span class="message-time">{{ msg.date }}</span>
              <div class="tick-icons">
                <ion-icon name="checkmark-outline" class="tick-icon"></ion-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showCreateConversationButton" class="w-100 h-100 d-flex justify-content-center align-items-center">
        <ion-button (click)="CreateChatConversationPair()">Create Chat</ion-button></div>
    </div>
  </div>
  <div class="message-input-container" >
    <div class="input-container">
      <textarea [disabled]="disableInputAndSendButton" (keyup.enter)="sendMessage()" [(ngModel)]="message" placeholder="Type a message..."
        class="message-input input" rows="1" (input)="autoResize($event)"></textarea>
    </div>
    <div class="button-group">
      <ion-button [disabled]="disableInputAndSendButton" class="send-button" (click)="sendMessage()">
        <ion-icon slot="icon-only" name="send-outline" class="send-btn"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>
<div *ngIf="!selectedUser" class="empty-message"></div>